<template>
  <div class="">
    <SidePageColumn side="right">
      <div class="text-left">
        <template v-for="(menu_item, index) in sub_menu_items">
          <NavbarMenuItem
            v-if="can_access(menu_item)"
            :key="index"
            :to="menu_item.to"
            :icon="menu_item.icon"
            :label="menu_item.label"
          ></NavbarMenuItem>
        </template>
      </div>
    </SidePageColumn>
    <CenterNavbar
      :crumps="attrs.crumps"
      :title="attrs.title"
      :width_class="page_info.center_width_class"
      :show_staff="!show_banner"
      :navbar_cols="(attrs.navbar_cols)? attrs.navbar_cols : 4 "
    ></CenterNavbar>
    <div class="inner-page-container">
      <div
        v-if="show_banner"
        class="text-center white d-flex flex-column justify-space-between align-center"
      >
        <div>
          <v-img
            width="400"
            height="400"
            contain
            src="https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1606683118/botswana%20services/website%20assets/newsletter_amaevv.jpg"
          >
          </v-img>
        </div>
        <p class="pa-10 text-h5 pb-0 pt-2 mb-15">
          Manage News Letter Subscriptions
          <br />
          <br />
          <v-btn
            class="ma-1 mb-4"
            dense
            rounded
            outlined
            color="success"
            @click="go_to_news_letters_list"
          >
            <v-icon left class="mobile-display-none">mdi-eye</v-icon>
            View Subscriptions
          </v-btn>
          <br /><br />
        </p>
      </div>
      <router-view
        :user="user"
        :is_loading="is_loading"
        @on-show-loader="$emit('on-hide-loader')"
        @on-hide-loader="$emit('on-show-loader')"
        @set-page-attributes="on_set_page_attributes"
      ></router-view>
    </div>
  </div>
</template>

<script>
import CenterNavbar from "./../../../components/CenterNavbar";
import page_info from "./../../../lib/page_info";
import SidePageColumn from "./../../../components/SidePageColumn";
import NavbarMenuItem from "./../../../components/NavbarMenuItem";
import Utils from "./../../../lib/Utils";
export default {
  name: "AdminNewsLetters",
  components: {
    CenterNavbar,
    SidePageColumn,
    Utils,
    NavbarMenuItem,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: false,
    },
  },
  data: () => ({
    page_info: page_info,
    sub_menu_items: [
      {
        label: "List Of Subscriptions",
        icon: "mdi-view-list",
        to: "/admin/new_letters/list",
        roles: ["super role", "backofficcee"],
      },
    ],
    attrs: Utils.get_default_page_attr(),
  }),
  methods: {
    can_access(menu_item) {
      var res = Utils.can_access(this.user, menu_item);
      return res;
    },
    on_set_page_attributes(attrs) {
      this.attrs = attrs;
    },
    go_to_news_letters_list() {
      this.$router.push("/admin/new_letters/list");
    }
  },
  computed: {
    show_banner() {
      if (this.$route.path == "/admin/new_letters") {
        return true;
      }
      return false;
    },
  }
};
</script>